import type { CustomerAuthField, CustomerAuthValues } from './validation'

type UpdateFieldOptions = {
  touch?: CustomerAuthField[]
  clear?: CustomerAuthField[]
}

type UpdateFieldFn = <K extends CustomerAuthField>(
  field: K,
  value: CustomerAuthValues[K],
  options?: UpdateFieldOptions,
) => void

export const buildCustomerAuthSetters = (updateField: UpdateFieldFn) => ({
  setEmail: (value: string) => {
    updateField('email', value)
  },
  setPassword: (value: string) => {
    updateField('password', value, { clear: ['password', 'confirmPassword'] })
  },
  setConfirmPassword: (value: string) => {
    updateField('confirmPassword', value)
  },
  setFirstName: (value: string) => {
    updateField('firstName', value)
  },
  setLastName: (value: string) => {
    updateField('lastName', value)
  },
  setTaxCode: (value: string) => {
    updateField('taxCode', value)
  },
  setGender: (value: string) => {
    updateField('gender', value)
  },
  setPhonePrefix: (value: string) => {
    updateField('phonePrefix', value)
  },
  setPhoneLocalNumber: (value: string) => {
    updateField('phoneLocalNumber', value)
  },
  setAddressStreet: (value: string) => {
    updateField('addressStreet', value)
  },
  setAddressStreetNumber: (value: string) => {
    updateField('addressStreetNumber', value)
  },
  setAddressCity: (value: string) => {
    updateField('addressCity', value)
  },
  setAddressPostalCode: (value: string) => {
    updateField('addressPostalCode', value)
  },
  setAddressProvince: (value: string) => {
    updateField('addressProvince', value)
  },
  setAddressCountry: (value: string) => {
    updateField('addressCountry', value)
  },
})
